import { updatesData } from '@/mocks/homepage';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">实时快讯</h2>
          <p className="text-sm text-foreground-500 mt-2"><i className="ri-timer-line mr-1"></i>7×24小时不间断更新</p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>
          <div className="space-y-5">
            {updatesData.map((item) => (
              <div key={item.id} className="flex gap-4 relative">
                <div className="w-10 h-10 flex-shrink-0 rounded-full bg-background-100 border-2 border-background-200 flex items-center justify-center z-10">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex-1 pt-2">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.time}</span>
                    {item.badge && (
                      <span className={`px-1.5 py-0.5 ${item.badgeColor} text-background-50 rounded text-xs font-medium whitespace-nowrap`}>
                        {item.badge}
                      </span>
                    )}
                  </div>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}